module.exports = __webpack_public_path__ + "static/img/img_01.8686a21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/fight-epidemic/img_01.jpg
// module id = x7Ah
// module chunks = 99